import { render, staticRenderFns } from "./PregnancySplash.vue?vue&type=template&id=3806904a&scoped=true&"
import script from "./PregnancySplash.vue?vue&type=script&lang=js&"
export * from "./PregnancySplash.vue?vue&type=script&lang=js&"
import style0 from "./PregnancySplash.vue?vue&type=style&index=0&id=3806904a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806904a",
  null
  
)

export default component.exports